"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransform = void 0;
const http_interfaces_1 = require("../types/http.interfaces");
const error_interfaces_1 = require("../types/error.interfaces");
const create_error_1 = require("../create-error");
const createTransform = (endpointModel) => async (response) => {
    try {
        if (endpointModel.transformResponse) {
            return await endpointModel.transformResponse(response);
        }
        if (response.status === http_interfaces_1.Status.NO_CONTENT) {
            return undefined;
        }
        const responseType = endpointModel.responseType ||
            responseTypeFromHeaders(response) ||
            "json";
        return await (response.body && response.body[responseType]?.());
    }
    catch (e) {
        if (e.name === "AbortError") {
            throw (0, create_error_1.createError)(error_interfaces_1.ErrorReason.RequestCancelled);
        }
        else {
            throw (0, create_error_1.createError)(error_interfaces_1.ErrorReason.TransformFailed, response, e);
        }
    }
};
exports.createTransform = createTransform;
function responseTypeFromHeaders(response) {
    if (response.headers) {
        const contentType = response.headers["content-type"];
        if (contentType) {
            if (contentType.indexOf("application/json") !== -1) {
                return "json";
            }
            if (contentType.indexOf("text/") !== -1) {
                return "text";
            }
        }
        if (response.headers["content-length"] === "0") {
            return "text";
        }
    }
    return undefined;
}
